import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=697133bc&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "./Orders.vue?vue&type=style&index=0&id=697133bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697133bc",
  null
  
)

export default component.exports